import { render, staticRenderFns } from "./ed-list-class-students.component.vue?vue&type=template&id=96d3ef7c&scoped=true&"
import script from "./ed-list-class-students.component.ts?vue&type=script&lang=ts&"
export * from "./ed-list-class-students.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-class-students.component.scss?vue&type=style&index=0&id=96d3ef7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d3ef7c",
  null
  
)

export default component.exports